<template>
  <sc-provider>
    <router-view />
  </sc-provider>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  setup() {
  },
});
</script>
